import React from "react";
import BoningOrdersPage from "./BoningOrdersPage";
import useBoningOrders from "./useBoningOrders";

function BoningOrders() {
  return <BoningOrdersPage {...useBoningOrders()} />;
}

export default BoningOrders;
